export class CloseSendEmailViewEvent {}
